import { getSplitSummary } from "selectors";

export function SplitValueGetter(props: any) {
  const { data, colDef } = props;
  if (!data) {
    return null;
  }
  const value = data[colDef.field];

  if (!value) {
    return null;
  }

  return getSplitSummary(value);
}

export const BusinessDefaultVendorSplitGetter = (params: any) => {
  const { data, context } = params;
  const { defaultVendorSplitByBusinessIdLookup } = context;

  if (!data || !defaultVendorSplitByBusinessIdLookup) {
    return "";
  }

  const { id: businessId } = data.business;
  const split = defaultVendorSplitByBusinessIdLookup[businessId];

  return getSplitSummary(split);
};

export const BusinessDefaultBuyerSplitGetter = (params: any) => {
  const { data, context } = params;
  const { defaultBuyerSplitByBusinessIdLookup } = context;
  if (!data || !defaultBuyerSplitByBusinessIdLookup) {
    return "";
  }

  const { id: businessId } = data.business;
  const split = defaultBuyerSplitByBusinessIdLookup[businessId];

  return getSplitSummary(split);
};
